import { useCallback, useContext, useEffect } from 'react';
import { SectionViewedLogger } from '@/vdp/Analytics';
import Section from '~/constants/vdp/section';
import { useScreenSize } from '~/context/common/DeviceContext';
import UiContext from '~/context/vdp/UiContext';
import { useGetHasImages } from '~/context/vdp/VehicleContext';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { logError } from '~/utilities/loggers';
import Carousel from './MobileCarousel';

function MobileGallery() {
  const { setSectionViewed } = useContext(UiContext);
  const hasImages = useGetHasImages();
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();

  const isHeightLessThan610 = useScreenSize().height < 610;
  const showGalleryCarousel = !shouldRenderCondensedHero && hasImages;
  const viewedThreshold = isHeightLessThan610 ? 0.2 : 0.9;

  const viewedCallback = useCallback(() => {
    setSectionViewed(Section.Gallery);
  }, [setSectionViewed]);

  useEffect(() => {
    if (hasImages) return;
    logError('No Gallery Images');
  }, [hasImages]);

  return showGalleryCarousel ? (
    <SectionViewedLogger
      callback={viewedCallback}
      section={Section.Gallery}
      threshold={viewedThreshold}
    >
      <Carousel />
    </SectionViewedLogger>
  ) : null;
}

export default withErrorBoundary(MobileGallery, {
  section: Section.Gallery
});
